import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const financeStore = {
    actionCreators,
    reducer,
};

export default financeStore;
